import {Spin} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import {CSSProperties} from 'react';

export const CustomLoading = (props: { style?: CSSProperties | undefined }) => {
  return (
    <Spin indicator={<LoadingOutlined style={{fontSize: 24, ...props.style}} spin/>}/>
  );
};